export default __webpack_public_path__ + "c3996ba.png";